import { apiFetch } from "../api.js";
import type {
  BudgetCategoriesListResponse,
  BudgetCategory,
  CreateBudgetCategoryInput,
  UpdateBudgetCategoryInput,
} from "./types.js";

/**
 * Budget categories API module — Phase 5 Session 2.
 *
 * - `deleteBudgetCategory` is soft (server sets `is_active = false`).
 *   Reactivation goes through `updateBudgetCategory({ is_active: true })`,
 *   not a separate "restore" endpoint.
 * - `listBudgetCategories` accepts an `includeInactive` flag; default
 *   hides inactive rows.
 */

export function listBudgetCategories(
  includeInactive = false,
): Promise<BudgetCategoriesListResponse> {
  const qs = includeInactive ? "?include_inactive=true" : "";
  return apiFetch<BudgetCategoriesListResponse>(
    `/v1/budget-categories${qs}`,
  );
}

export function createBudgetCategory(
  input: CreateBudgetCategoryInput,
): Promise<BudgetCategory> {
  return apiFetch<BudgetCategory>("/v1/budget-categories", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateBudgetCategory(
  categoryId: string,
  input: UpdateBudgetCategoryInput,
): Promise<BudgetCategory> {
  return apiFetch<BudgetCategory>(`/v1/budget-categories/${categoryId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteBudgetCategory(categoryId: string): Promise<void> {
  return apiFetch<void>(`/v1/budget-categories/${categoryId}`, {
    method: "DELETE",
  });
}
